/**
 * cpanel build version, injected at compile time (see `vite.config.ts`).
 *
 * The `typeof` guard keeps this module safe in any runner that skips the
 * define (Vite 8 dev leaves bare-identifier defines unreplaced; only the
 * production bundle substitutes them): instead of throwing
 * `ReferenceError: __APP_VERSION__ is not defined`, those contexts get an
 * explicit dev marker. Note `typeof` is safe on a missing global, and once
 * the bundler substitutes the identifier the guard folds to the real string.
 */
export const APP_VERSION: string =
  typeof __APP_VERSION__ === 'undefined' ? 'v.0.0.0-dev' : __APP_VERSION__;
